import React from "react";
import {LucideIcon} from "lucide-react";
import {cn} from "./cn";

export interface TabItem {
    key: string;
    label: string;
    icon?: LucideIcon;
}

export interface TabsProps {
    tabs: TabItem[];
    active: string;
    onChange: (key: string) => void;
    className?: string;
}

export const Tabs: React.FC<TabsProps> = ({tabs, active, onChange, className}) => (
    <div className={cn("inline-flex items-center gap-1 p-1 rounded-xl bg-surface-sunken w-fit", className)}>
        {tabs.map(t => (
            <button
                key={t.key}
                type="button"
                onClick={() => onChange(t.key)}
                className={cn(
                    "flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-sm font-semibold transition-all duration-150",
                    active === t.key ? "bg-surface text-ink shadow-xs" : "text-ink-muted hover:text-ink"
                )}
            >
                {t.icon && <t.icon size={14} strokeWidth={2.25}/>}
                {t.label}
            </button>
        ))}
    </div>
);
